module.exports = __webpack_public_path__ + "static/media/country_ss.b531dfa3.webp";